const colors = {
  // light_background: '#c5c5c5',
  primary: '#5843E4',
  secondary: '#8186A0',
  backgroundLight: '#F9F9FC',
};

export default colors;
